import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-verify-email-user', (editor, opts = {}) => {
  const config = {
    blocks: [
      'verifyUserEmailComponent',
    ],
    name: 'verifyUserEmailComponent',
    stylePrefix: 'gjs-',
    labelComponent: 'Componente Verificacion de Correo',
    defText: 'Sample',
    category: 'Interacción de Usuario',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
